import { urlParamsToMap } from './util/urls'

export const getApiUrl = () => {
  const isLocal = window.location.host.indexOf('localhost') !== -1
  return isLocal ? 'http://localhost:8001/api' : '/api'
}

const config = {
  baseUrl: getApiUrl(),
}

export const getSessionId = (): string => {
  const params = urlParamsToMap(window.location.search)
  if (params.token) {
    localStorage.setItem('MagnoToken', params.token)
    return params.token
  }
  return localStorage.getItem('MagnoToken') || ''
}

export const authedGet = async (path: string) => {
  const result = await fetch(`${config.baseUrl}/${path}`, {
    method: 'GET',
    credentials: 'same-origin',
    headers: {
      'X-authenticated': getSessionId(),
      Cookie: document.cookie,
    },
  })
  return result
}

const authedMutate = async (method: string, path: string, body: object) => {
  const result = await fetch(`${config.baseUrl}/${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
      'X-authenticated': getSessionId(),
    },
    body: JSON.stringify(body),
  })
  return result
}

export const authedDelete = async (path: string, body: object) => {
  return await authedMutate('DELETE', path, body)
}

export const authedPut = async (path: string, body: object) => {
  return await authedMutate('PUT', path, body)
}

export const authedPost = async (path: string, body: object) => {
  return await authedMutate('POST', path, body)
}
